"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { useRouter } from "next/navigation";
import { FaRegBookmark, FaRegCommentDots } from "react-icons/fa";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import ImageWithText from "../ui/imagewithtext";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getSectionUrl, getFocusPointStyle, ImageMetadata } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  category?: FieldConfig;
  sectionUrl?: string;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};
export default function VerticalheadingBigImageNews(t0) {
  const $ = _c(50);
  const {
    category: t1,
    sectionUrl,
    title: t2,
    excerpt: t3,
    imageSrc: t4,
    slug,
    priority: t5
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? {
      hidden: false,
      value: "INDIA",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const category = t6;
  let t7;
  if ($[2] !== t2) {
    t7 = t2 === undefined ? {
      hidden: false,
      value: "\u0BB0\u0BAF\u0BBF\u0BB2\u0BCD \u0BB5\u0BBF\u0BAA\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0BA3\u0BC1 \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1 \u0B95\u0BCB\u0BB3\u0BBE\u0BB1\u0BC7 \u0B95\u0BBE\u0BB0\u0BA3\u0BAE\u0BCD...- \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD\u0BB5\u0BC7 \u0B85\u0BAE\u0BC8\u0B9A\u0BCD\u0B9A\u0BB0\u0BCD \u0BA4\u0B95\u0BB5\u0BB2\u0BCD..!",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const title = t7;
  let t8;
  if ($[4] !== t3) {
    t8 = t3 === undefined ? {
      hidden: false,
      value: "\u0BAE\u0BC7\u0BB1\u0BCD\u0B95\u0BC1\u0BB5\u0B99\u0BCD\u0B95 \u0BAE\u0BBE\u0BA8\u0BBF\u0BB2\u0BAE\u0BCD \u0BB7\u0BBE\u0BB2\u0BBF\u0BAE\u0BB0\u0BBF\u0BB2\u0BCD \u0B87\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 \u0B9A\u0BC6\u0BA9\u0BCD\u0BA9\u0BC8 \u0BA8\u0BCB\u0B95\u0BCD\u0B95\u0BBF \u0BB5\u0BA8\u0BCD\u0BA4 \u0B95\u0BCB\u0BB0\u0BAE\u0BA3\u0BCD\u0B9F\u0BB2\u0BCD \u0BB5\u0BBF\u0BB0\u0BC8\u0BB5\u0BC1 \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD, \u0B92\u0B9F\u0BBF\u0B9A\u0BBE \u0BAE\u0BBE\u0BA8\u0BBF\u0BB2\u0BAE\u0BCD \u0BAA\u0BBE\u0BB2\u0B9A\u0BCB\u0BB0\u0BCD \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD \u0BA8\u0BBF\u0BB2\u0BC8\u0BAF\u0BAE\u0BCD \u0B85\u0BB0\u0BC1\u0B95\u0BC7 \u0B9A\u0BC6\u0BA9\u0BCD\u0BB1 \u0B9A\u0BBF\u0BB2 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD \u0B95\u0BCB\u0BB0\u0BAE\u0BA3\u0BCD\u0B9F\u0BB2\u0BCD \u0BB5\u0BBF\u0BB0\u0BC8\u0BB5\u0BC1 \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD, \u0B92\u0B9F\u0BBF\u0B9A\u0BBE \u0BAE\u0BBE\u0BA8\u0BBF\u0BB2\u0BAE\u0BCD \u0BAA\u0BBE\u0BB2\u0B9A\u0BCB\u0BB0\u0BCD \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD \u0BA8\u0BBF\u0BB2\u0BC8\u0BAF\u0BAE\u0BCD \u0B85\u0BB0\u0BC1\u0B95\u0BC7 \u0B9A\u0BC6\u0BA9\u0BCD\u0BB1 \u0B9A\u0BBF\u0BB2 ",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const excerpt = t8;
  let t9;
  if ($[6] !== t4) {
    t9 = t4 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t4;
    $[6] = t4;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const imageSrc = t9;
  const priority = t5 === undefined ? false : t5;
  const router = useRouter();
  const categoryValue = category?.value || "";
  const titleValue = title?.value || "";
  const excerptValue = excerpt?.value || "";
  let t10;
  if ($[8] !== imageSrc?.value) {
    t10 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[8] = imageSrc?.value;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const imageSrcValue = t10;
  let t11;
  if ($[10] !== sectionUrl) {
    t11 = getSectionUrl(sectionUrl);
    $[10] = sectionUrl;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const sectionUrlValue = t11;
  let t12;
  if ($[12] !== category?.customClass || $[13] !== category?.hidden || $[14] !== categoryValue || $[15] !== router || $[16] !== sectionUrlValue) {
    t12 = !category?.hidden && (sectionUrlValue ? <span className={`text-16-english-600 text-012061 tracking-wide uppercase hover:underline cursor-pointer ${category?.customClass || ""}`} onClick={e => {
      e.preventDefault();
      e.stopPropagation();
      router.push(sectionUrlValue);
    }}>{categoryValue}</span> : <div className={`text-16-english-600 text-012061 tracking-wide uppercase ${category?.customClass || ""}`}>{categoryValue}</div>);
    $[12] = category?.customClass;
    $[13] = category?.hidden;
    $[14] = categoryValue;
    $[15] = router;
    $[16] = sectionUrlValue;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const t13 = slug ? `/${slug}` : undefined;
  let t14;
  if ($[18] !== excerptValue || $[19] !== imageSrcValue || $[20] !== slug || $[21] !== t13 || $[22] !== titleValue) {
    t14 = <div className="flex items-center justify-between"><MessageIcon id="message-icon-1" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} thumbnailUrl={imageSrcValue} description={excerptValue} articleUrl={t13} /></div>;
    $[18] = excerptValue;
    $[19] = imageSrcValue;
    $[20] = slug;
    $[21] = t13;
    $[22] = titleValue;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t12 || $[25] !== t14) {
    t15 = <div className="flex justify-between items-center">{t12}{t14}</div>;
    $[24] = t12;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== title?.customClass || $[28] !== title?.hidden || $[29] !== titleValue) {
    t16 = !title?.hidden && <h3 className={`text-012061 text-24-tamil-700 md:text-16-tamil-700 leading-[1.4] ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[27] = title?.customClass;
    $[28] = title?.hidden;
    $[29] = titleValue;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== excerpt?.customClass || $[32] !== excerpt?.hidden || $[33] !== excerptValue) {
    t17 = !excerpt?.hidden && <p className={`text-4D4D4D text-18-tamil-400 leading-[1.4] line-clamp-3 ${excerpt?.customClass || ""}`}>{excerptValue}</p>;
    $[31] = excerpt?.customClass;
    $[32] = excerpt?.hidden;
    $[33] = excerptValue;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t15 || $[36] !== t16 || $[37] !== t17) {
    t18 = <div className="flex flex-col gap-4">{t15}{t16}{t17}</div>;
    $[35] = t15;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== imageSrc?.customClass || $[40] !== imageSrc?.hidden || $[41] !== imageSrcValue || $[42] !== priority) {
    t19 = !imageSrc?.hidden && <div className={`relative w-full aspect-[16/9] overflow-hidden ${imageSrc?.customClass || ""}`}><ImageWithText text={"\u0BB0\u0BAF\u0BBF\u0BB2\u0BCD \u0BB5\u0BBF\u0BAA\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0BA3\u0BC1 \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1 \u0B95\u0BCB\u0BB3\u0BBE\u0BB1\u0BC7 \u0B95\u0BBE\u0BB0\u0BA3\u0BAE\u0BCD..."} imageSrc={imageSrcValue} priority={priority} /></div>;
    $[39] = imageSrc?.customClass;
    $[40] = imageSrc?.hidden;
    $[41] = imageSrcValue;
    $[42] = priority;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t18 || $[45] !== t19) {
    t20 = <article className="flex flex-col overflow-hidden p-4 gap-4 bg-DCDCDC">{t18}{t19}</article>;
    $[44] = t18;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  const content = t20;
  if (slug) {
    const t21 = `/${slug}`;
    let t22;
    if ($[47] !== content || $[48] !== t21) {
      t22 = <Link href={t21} className="block hover:bg-gray-100 transition-colors cursor-pointer">{content}</Link>;
      $[47] = content;
      $[48] = t21;
      $[49] = t22;
    } else {
      t22 = $[49];
    }
    return t22;
  }
  return content;
}